<template>
    <div>
        <div class="card">
            <!-- :rowClass="rowClass" -->
            <DataTable v-model:selection="selectedAttributes" :value="allAttributes" :lazy="true" ref="dt" dataKey="id" :loading="loading" responsiveLayout="scroll">
                <template #header>
                    <div class="flex justify-content-between flex-column sm:flex-row">
                        <div class="flex">
                            <div v-if="authStore.isGodUser && selectedAttributes && selectedAttributes.length">
                                <Button
                                    :label="sharedType === SharedTypes.COMPANY ? 'Export to Shared' : 'Import to Company'"
                                    class="p-button-warning mr-2"
                                    @click="confirmTransfer(selectedAttributes, sharedType === SharedTypes.COMPANY, attributeStore.transferAttributes)"
                                />
                            </div>
                        </div>
                    </div>
                </template>
                <template #empty> No attributes available. </template>
                <template #loading> Loading Attributes. Please wait. </template>
                <Column selectionMode="multiple" headerStyle="width: 3rem" />
                <Column field="id" header="ID" style="max-width: 6rem" />
                <Column field="label" header="LABEL" style="max-width: 10rem">
                    <template #body="slotProps">
                        {{ slotProps.data.label ? slotProps.data.label : 'No Label' }}
                    </template>
                </Column>
                <Column field="code" header="CODE" style="max-width: 10rem" />
                <Column field="version" header="VERSION" style="max-width: 4rem" />
                <Column field="default" header="DEFAULT" style="max-width: 4rem">
                    <template #body="slotProps">
                        <Tag :severity="slotProps.data.default == 1 ? 'info' : 'danger'" :value="slotProps.data.default == 1 ? 'True' : 'False'" rounded />
                    </template>
                </Column>
                <Column field="type" header="TYPE" style="max-width: 5rem" />
                <Column field="created_at" header="CREATED AT" style="max-width: 6rem" />
                <Column field="actions" header="ACTIONS" style="max-width: 10rem">
                    <template #body="slotProps">
                        <!-- <Button icon="pi pi-eye" class="p-button-rounded p-button-info mr-2" @click="operateAttribute(slotProps.data.id, 'view')" v-tooltip="'View Attribute Details'" />  -->
                        <Button v-if="authStore.hasPermission(UserPermission.WRITE_ASSESSMENT_ATTRIBUTES)" icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="editDetails(slotProps.data.id)" v-tooltip="'Edit Attribute'" />
                        <!-- check permissions for deletion of normal attributes as well as user profile attributes -->
                        <Button
                            v-if="(authStore.hasPermission(UserPermission.DELETE_ASSESSMENT_ATTRIBUTES) && !slotProps.data.user_profile) || (authStore.hasPermission(UserPermission.DELETE_USER_PROFILE_ATTRIBUTES) && slotProps.data.user_profile)"
                            icon="pi pi-trash"
                            class="p-button-rounded p-button-danger mr-2"
                            @click="confirmRequest(slotProps.data, attributeStore.deleteAttribute)"
                            v-tooltip="'Delete Attribute'"
                        />
                        <Button
                            v-if="authStore.hasPermission(UserPermission.WRITE_ASSESSMENT_ATTRIBUTES) && slotProps.data.default != 1"
                            icon="pi pi-check"
                            class="p-button-rounded p-button-help"
                            @click="confirmRequest(slotProps.data, attributeStore.setDefaultAttribute, 'default')"
                            v-tooltip="'Set Default'"
                        />
                    </template>
                </Column>
            </DataTable>
        </div>
        <!-- Attribute edit form -->
        <attribute-form v-if="editDialogForm" @hide-dialog="editDialogForm = false" />
    </div>
</template>

<script setup>
import AttributeForm from './AttributeForm.vue';
import { ref, computed, onMounted, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { authStore, attributeStore } from '../../../../../store/global-stores';
import { useConfirmRemove } from '../../../../../composables/ConfirmComposable';
import { UserPermission } from '../../../../../modules/permission/enum';
import { SharedTypes } from '../../../enum';

const { allAttributes, loading } = storeToRefs(attributeStore);
const { confirmRequest, confirmTransfer } = useConfirmRemove();

const editDialogForm = ref(false);
const selectedAttributes = ref([]);

const sharedType = computed(() => {
    return attributeStore.params.shared;
});

watch(sharedType, () => {
    selectedAttributes.value = null;
});

onMounted(() => {
    loadAttributes();
    loadSharedTaggedAttributes();
});

const loadAttributes = async () => {
    await attributeStore.fetchAllAttributes();
};

const loadSharedTaggedAttributes = async () => {
    await attributeStore.fetchAllSharedTaggedAttributes();
};

const editDetails = (attributeId) => {
    editDialogForm.value = true;
    attributeStore.editAttribute(attributeId);
};
</script>
